import {
  faBan,
  faHistory,
  faLink,
  faPlus,
  faEllipsisV,
} from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Button, Menu, Flex } from '@mantine/core'
import React from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useInquiryActions } from '../../hooks/useInquiryActions'

export type CellActionsProps = {
  inquiry?: CoreInquiry
}

export function CellActions({ inquiry }: CellActionsProps) {
  const {
    handleApprove,
    handleReopen,
    handleOpenBooking,
    openRejectModal,
    inquiryStatus,
    bookingId,
  } = useInquiryActions({ inquiry })

  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const isExpired = inquiryStatus === 'expired'
  const isRejected = inquiryStatus === 'rejected'
  const isRequested = inquiryStatus === 'requested'
  const isApproved = inquiryStatus === 'approved'

  const approveButton = (
    <Button
      size='sm'
      variant='default'
      leftSection={<Icon icon={faLink} />}
      onClick={handleOpenBooking}
      data-testid='open-booking'
      disabled={!bookingId}
    >
      {bookingId
        ? t('open-booking', { replace: { id: bookingId } })
        : t('booking-deleted')}
    </Button>
  )

  return (
    <Flex
      align='center'
      gap='sm'
      justify='flex-end'
      onClick={(e) => e.stopPropagation()}
    >
      {inquiryStatus === 'approved' && approveButton}
      {inquiryStatus === 'requested' && (
        <Button
          size='sm'
          variant='default'
          disabled={isExpired}
          leftSection={<Icon icon={faPlus} />}
          onClick={handleApprove}
          data-testid='create-booking'
        >
          {t('create-booking')}
        </Button>
      )}
      <Menu withinPortal position='bottom-end'>
        <Menu.Target>
          <ActionIcon
            size='sm'
            variant='default'
            onClick={(e) => e.stopPropagation()}
          >
            <Icon icon={faEllipsisV} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown onClick={(e) => e.stopPropagation()}>
          <Menu.Item
            leftSection={<Icon icon={faHistory} color='gray.7' />}
            onClick={handleReopen}
            disabled={isExpired || isRequested}
          >
            {t('reopen_request')}
          </Menu.Item>
          <Menu.Item
            leftSection={<Icon icon={faBan} color='gray.7' />}
            onClick={() => openRejectModal({ inquiry })}
            disabled={isExpired || isRejected || isApproved}
          >
            {t('reject_request')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Flex>
  )
}
